<!--
 * @Author: 朱占伟
 * @LastEditors: 黄露
 * @description: Rank排名曲线图
 * @Date: 2021-07-27 21:13:07
 * @LastEditTime: 2021-11-29 10:28:07
-->
<template>
  <div class="echarts">
    <van-popup
      v-model:show="show"
      :lazy-render="config.lazyrender"
      round
      closeable
      position="bottom"
      class="vant-popup-box"
      teleport="body"
    >
      <div v-if="!isMaintain" ref="myEcharts" class="my-echarts" />
      <div v-if="isMaintain">
        <div class="maintain-wrap">
          <img src="../../assets/images/maintain/maintain.svg" alt="">
          <div class="maintain-text">
            Function under maintenance
          </div>
          <!-- <div class="maintain-btn mt-10">
            <el-button @click="openContactUs">
              {{ $t('contactUs') }}
            </el-button>
          </div> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import echarts from 'utils/injectEcharts';
import { ref, reactive } from 'vue';
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          lazyrender: false,

        };
      }
    }
  },
  setup() {
    const show = ref(false);
    const isMaintain = ref(false)
    const myEcharts=ref(null)
    // 折线图配置文件
    const option = reactive({
      title: {
        top: '5%',
        right: '42%',
        text: 'Rank'
      },
      tooltip:{},
      grid: {
        bottom: '12%',
        right: '30vw',
        left: '50vw',
        height: 140
      },
      legend: {
        top: '20%',
        data: ['Series 1']
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        min:1,
        type: 'value',
        minInterval: 1,
        inverse:true,
      },
      series: [
        {
          name: 'Series 1',
          symbol:'circle', //拐点样式
          data: [],
          type: 'line',
          lineStyle: {
            color: '#6153ff'
          },
          itemStyle:{
            normal:{
              color:'#6153ff',//拐点颜色
              borderColor:'#6153ff',//拐点边框颜色
            },
          }
          // areaStyle: {
          //   color: {
          //     type: 'linear',
          //     x: 0,
          //     y: 0,
          //     x2: 0,
          //     y2: 1,
          //     colorStops: [{
          //       offset: 0, color: 'rgba(97, 83, 255,.3)' // 0% 处的颜色
          //     }, {
          //       offset: 1, color: 'rgba(97, 83, 255,.1)' // 100% 处的颜色
          //     }],
          //     global: false // 缺省为 false
          //   }
          // }
        }
      ]
    });

    const showPopup = (config) => {
      if(!config)return;
      if(config.isMaintain){
        isMaintain.value = true
        show.value = true
        return 
      }
      if(config.xData && Array.isArray(config.xData)){
        option.xAxis.data = config.xData
      }
      if(config.data && Array.isArray(config.data)){
        option.series[0].data = config.data
      }
      option.title.text = config.text
      option.yAxis.inverse = config.isRe
      show.value = true;
      var myChart = echarts.init(myEcharts.value);
      option && myChart.setOption(option);
    };
    return {
      show,
      showPopup,
      myEcharts,
      isMaintain
    };
  }
};
</script>

<style lang="scss" scoped>
.vant-popup-box,
.my-echarts {
  width: 100vw;
  height: 300px;
}

.echarts {
  :deep(.van-overlay) {
    z-index: 10003 !important;
  }

  :deep(.vant-popup-box) {
    z-index: 10003 !important;
  }
}

.maintain-wrap {
    padding: 16px;
    text-align: center;
    border-radius: 0px 0px 0px 0px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.maintain-text {
    color: #666;
    font-size: 12px;
}
.maintain-btn {
    /deep/ .el-button {
        background: rgba(97,83,255,0.1);

        span {
            font-size: 12px;
            color: #6153ff;
        }
    }
}

</style>
